module.exports = __webpack_public_path__ + "img/064-cloudy-night-2.abf3db92.svg";